// Access-token role names shared with the backend's AccessRole enum.
export const AccessRole = Object.freeze({
  UNVERIFIED: "UNVERIFIED",
  TUTORIAL: "TUTORIAL",
  CREATE_COMPANY: "CREATE_COMPANY",
  USER: "USER",
  ADMIN: "ADMIN",
});

export const getEntryPath = (role) => role === AccessRole.TUTORIAL ? "/tutorial"
  : role === AccessRole.CREATE_COMPANY ? "/create-company" : "/me/dailyreport";
